import {
  getCurrentAccount,
  useCurrentAccount,
} from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { useStore } from 'zustand';

type Props = {
  symbol: string;
};

export default function EntryPrice({ symbol }: Props) {
  const entryPrice = useCurrentAccount((state) => {
    const { cost, size } = state.positions[symbol];
    return cost / size;
  });
  const priceDecimals = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.priceDecimals,
  );
  return formatBigInt(entryPrice, priceDecimals, {
    style: 'currency',
    digits: Number(priceDecimals),
  });
}

export const entryPriceAccessorFn = (symbol: string) => {
  const {
    marketSpec: { priceDecimals },
  } = useMarketStore(symbol).getState();
  const { cost, size } = getCurrentAccount((state) => state.positions[symbol]);
  return bigIntToNum(cost / size, priceDecimals);
};
